/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3IcpXdrConversionRatesFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3IcpXdrConversionRatesFormat = ClosedEnum<
  typeof GetApiV3IcpXdrConversionRatesFormat
>;

export type GetApiV3IcpXdrConversionRatesRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3IcpXdrConversionRatesFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3IcpXdrConversionRatesFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3IcpXdrConversionRatesFormat
> = z.nativeEnum(GetApiV3IcpXdrConversionRatesFormat);

/** @internal */
export const GetApiV3IcpXdrConversionRatesFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3IcpXdrConversionRatesFormat> =
    GetApiV3IcpXdrConversionRatesFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3IcpXdrConversionRatesFormat$ {
  /** @deprecated use `GetApiV3IcpXdrConversionRatesFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3IcpXdrConversionRatesFormat$inboundSchema;
  /** @deprecated use `GetApiV3IcpXdrConversionRatesFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3IcpXdrConversionRatesFormat$outboundSchema;
}

/** @internal */
export const GetApiV3IcpXdrConversionRatesRequest$inboundSchema: z.ZodType<
  GetApiV3IcpXdrConversionRatesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  end: z.nullable(z.number().int()).default(null),
  format: GetApiV3IcpXdrConversionRatesFormat$inboundSchema.default("json"),
  start: z.nullable(z.number().int()).default(null),
  step: z.number().default(600),
});

/** @internal */
export type GetApiV3IcpXdrConversionRatesRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3IcpXdrConversionRatesRequest$outboundSchema: z.ZodType<
  GetApiV3IcpXdrConversionRatesRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3IcpXdrConversionRatesRequest
> = z.object({
  end: z.nullable(z.number().int()).default(null),
  format: GetApiV3IcpXdrConversionRatesFormat$outboundSchema.default("json"),
  start: z.nullable(z.number().int()).default(null),
  step: z.number().default(600),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3IcpXdrConversionRatesRequest$ {
  /** @deprecated use `GetApiV3IcpXdrConversionRatesRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3IcpXdrConversionRatesRequest$inboundSchema;
  /** @deprecated use `GetApiV3IcpXdrConversionRatesRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3IcpXdrConversionRatesRequest$outboundSchema;
  /** @deprecated use `GetApiV3IcpXdrConversionRatesRequest$Outbound` instead. */
  export type Outbound = GetApiV3IcpXdrConversionRatesRequest$Outbound;
}

export function getApiV3IcpXdrConversionRatesRequestToJSON(
  getApiV3IcpXdrConversionRatesRequest: GetApiV3IcpXdrConversionRatesRequest,
): string {
  return JSON.stringify(
    GetApiV3IcpXdrConversionRatesRequest$outboundSchema.parse(
      getApiV3IcpXdrConversionRatesRequest,
    ),
  );
}

export function getApiV3IcpXdrConversionRatesRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3IcpXdrConversionRatesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3IcpXdrConversionRatesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3IcpXdrConversionRatesRequest' from JSON`,
  );
}
